import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 매물 모아보기 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 오직 엔젤리그에서만 볼 수 있는 조합원 자격 매물을")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 1:1로 즉시 거래 해보세요 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 조합원 자격 팔기 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 1달 이내 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" MY매물 ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"26px","height":"16px"},
  src: "/assets/icon/btn_down_g@2x.png"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_button_s = _resolveComponent("ag-button-s")!
  const _component_regist_sell_stake_modal = _resolveComponent("regist-sell-stake-modal")!
  const _component_view_my_stake = _resolveComponent("view-my-stake")!
  const _component_stake_info_modal = _resolveComponent("stake-info-modal")!
  const _component_link_account_modal = _resolveComponent("link-account-modal")!
  const _component_buy_stake_modal = _resolveComponent("buy-stake-modal")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_toggle_icon = _resolveComponent("ag-toggle-icon")!
  const _component_stake_item = _resolveComponent("stake-item")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!

  return (_openBlock(), _createBlock(_component_ag_modal, {
    height: "calc(100% - 50px)",
    "model-value": _ctx.isOpenRef,
    "safe-area": true,
    "swipe-to-close": true,
    "onUpdate:modelValue": _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, {
        pt: "10px",
        pb: "10px",
        handle: true
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createVNode(_component_ag_box_s, { css: {p: 20, mb: 'safeAreaBottom'} }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text_s, { css: {dp: 'block', typography: 'tit24b', mb: 8} }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text_s, { css: {typography: 'main14r'} }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, {
                css: {mt: 16, mb: 24, textAlign: 'center'},
                "margin-top": "16px",
                "margin-bottom": "24px",
                "text-align": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text_s, {
                    css: {typography: 'main14r', color: _ctx.isAvaliable ? 'primary' : 'gray3'},
                    typography: "main14r",
                    color: _ctx.isAvaliable ? 'primary' : 'gray3'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.sellingMessage), 1)
                    ]),
                    _: 1
                  }, 8, ["css", "color"]),
                  _createVNode(_component_ag_button_s, {
                    css: {mt: 8, block: 'md', corner: 'full', outline: 'primary', width: '100%'},
                    disabled: !_ctx.isAvaliable,
                    onClickCapture: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합지분 팔기 버튼', 'clickContent':`조합원 자격 팔기`});(_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.checkIsLinked())})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_regist_sell_stake_modal, {
                    "open-type": _ctx.SellOpenType,
                    "is-open": _ctx.stakeSellOpen,
                    onCloseWithResult: _ctx.branchResult,
                    onClose: _cache[1] || (_cache[1] = () => _ctx.stakeSellOpen = false)
                  }, null, 8, ["open-type", "is-open", "onCloseWithResult"]),
                  (_ctx.viewMyStakeOpen)
                    ? (_openBlock(), _createBlock(_component_view_my_stake, {
                        key: 0,
                        "open-type": _ctx.viewOpenType,
                        "is-open": true,
                        onEdit: _ctx.editMyStake,
                        onReload: _ctx.reloadSellData,
                        onClose: _cache[2] || (_cache[2] = () => _ctx.viewMyStakeOpen = false)
                      }, null, 8, ["open-type", "onEdit", "onReload"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_stake_info_modal, {
                    "model-value": _ctx.detailInfoOpen,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => _ctx.detailInfoOpen = value),
                    onGoTo: _cache[4] || (_cache[4] = (value) => _ctx.buyNextProcess(value)),
                    onCompanyClick: _cache[5] || (_cache[5] = ($event) => _ctx.useCompanyModal($event, 'share-sell')),
                    onCancel: _ctx.reloadBuyData,
                    onCloseParent: _ctx.closeModal
                  }, null, 8, ["model-value", "onCancel", "onCloseParent"]),
                  (_ctx.linkAccountModal)
                    ? (_openBlock(), _createBlock(_component_link_account_modal, {
                        key: 1,
                        "model-value": true,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = (value) => _ctx.linkAccountModal = value),
                        onComplete: _ctx.afterLinkAccountAct
                      }, null, 8, ["onComplete"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_buy_stake_modal, {
                    "is-open": _ctx.buyStakeModal,
                    onBuyDone: _ctx.moveToMyPage,
                    onClose: _cache[7] || (_cache[7] = () => _ctx.buyStakeModal = false)
                  }, null, 8, ["is-open", "onBuyDone"])
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {corner: 10, bg: 'bg1', p: 16, dp: 'flex'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_toggle_icon, {
                    value: _ctx.filterFlag.withinAMonth,
                    name: "check",
                    onClick: _cache[8] || (_cache[8] = () => {
              _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'필터', 'clickContent':`1달 이내`});
              (_ctx.filterFlag.withinAMonth = !_ctx.filterFlag.withinAMonth);
            })
                  }, null, 8, ["value"]),
                  _createVNode(_component_ag_text_s, { css: {dp: 'block', mr: 24, ml: 8, typography: 'main14r'} }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_toggle_icon, {
                    value: _ctx.filterFlag.myItem,
                    "margin-right": "8px",
                    name: "check",
                    onClick: _cache[9] || (_cache[9] = () => {
              _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'필터', 'clickContent':`MY매물`});
              (_ctx.filterFlag.myItem = !_ctx.filterFlag.myItem);
            })
                  }, null, 8, ["value"]),
                  _createVNode(_component_ag_text_s, { css: {dp: 'block', ml: 8, typography: 'main14r'} }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', justifyContent: 'space-between', dd:'row', alignItems: 'center', mt: 18} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_box_s, { css: {
              color:'gray2',
              typography:'text14r',
            } }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 매물 " + _toDisplayString(_ctx.displayedCount), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합지분 목록', 'clickContent':`보기옵션`});_ctx.createModal()})
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_text_s, { css: {color: 'gray3', typography: 'main13r'} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.viewType), 1)
                        ]),
                        _: 1
                      }),
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedStake, (stake) => {
                return _withDirectives((_openBlock(), _createBlock(_component_stake_item, {
                  key: stake.partnershipShareSellId,
                  "stake-info": stake,
                  onClickCapture: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합지분 목록', 'clickContent':`${stake.partnershipName}`});(_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.printDetailModal(stake))}
                }, null, 8, ["stake-info", "onClickCapture"])), [
                  [_vShow, _ctx.viewToggle(stake)]
                ])
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}